import React from 'react'
import { t } from 'ttag'

import { InformationModal } from 'components/modals/common/InformationModal/InformationModal'

export const DeleteDepartmentWarningModal = ({
  onClose,
  onConfirm,
  isOpen,
}) => (
  <InformationModal
    confirmLabel={t`Close`}
    message={t`Removing this particular department is disabled.`}
    text={t`You cannot remove this Department because it has jobs assigned to it. Remove or reassign them in order to remove this department.`}
    title={t`Remove department`}
    {...{ onClose, onConfirm, isOpen }}
  />
)
